<!-- 车辆出库明细 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";
export default {
  name: "store-management/index/index",
  mixins: [crudMixins],
  components: {},
  data() {
    return {
      apiConfig: { getList, getDetail },
      defaultParams: {
        businessType: 2, // 必须传2，只查询汽车出库
      },
      option: {
        ...this.$store.state.publicOption,
        menu: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        column: [
          // 查询条件字段（隐藏）
          {
            label: "车牌号",
            prop: "trainNumber",
            search: true,
            type: "input",
            searchPlaceholder: "请输入车辆牌照",
          },
          {
            label: "客户",
            prop: "custNo",
            search: true,
            type: "select",
            remote: true,
            hide: true,
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            ...getSearchTimeConfig(),
            paramsKey: ["startTime", "endTime"],
            // searchValue: [getMonthStartTime(), getTodayEndTime()],
            hide: true,
          },

          // 表格显示字段
          {
            label: "计划号",
            prop: "planNo",
            overHidden: true,
          },
          {
            label: "客户",
            prop: "custName",
            overHidden: true,
          },
          {
            label: "物资类型",
            prop: "cargoName",
            align: "center",
          },
          {
            label: "库区",
            prop: "stockCode",
            search: true,
            type: "select",
            remote: true,
            dicUrl: "/api/produce/store/select/distinct/pycode?storeName={{key}}",
            props: { label: "storeName", value: "storeNo" },

          },
          {
            label: "空车时间",
            prop: "emptyTime",
            align: "center",
            overHidden: true,
          },
          {
            label: "重车时间",
            prop: "heavyTime",
            align: "center",
            overHidden: true,
          },
          {
            label: "皮重(吨)",
            prop: "tareWeight",
            align: "center",
          },
          {
            label: "毛重(吨)",
            prop: "grossWeight",
            align: "center",
          },
          {
            label: "净重(吨)",
            prop: "netWeight",
            align: "center",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
// 表格样式优化
:deep(.el-table) {
  .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 600;
    }
  }

  .el-table__body-wrapper {
    tr:hover {
      background-color: #f5f7fa;
    }
  }
}

// 搜索表单样式
:deep(.el-form-item) {
  margin-bottom: 18px;
}

:deep(.el-input__inner) {
  border-radius: 4px;
}

:deep(.el-button) {
  border-radius: 4px;
}
</style>
